import { StylesConfig } from 'react-select';
import { colours, device } from '../../../styles/constants';
import { lg, xl } from '../../../styles/mixins';
import { Option } from './CountrySelect';
import styled from 'styled-components';

const itemHeight = 3;
const listPadding = 0.45;

export const SelectContainer = styled.div`
  font-size: 16px;
`;

export const selectStyles: StylesConfig<Option> = {
  singleValue: (provided) => ({
    ...provided,
    margin: 0,
    fontSize: 17,
    color: colours.black,
    fontWeight: 400,
    overflow: 'visible',
  }),
  control: (provided, state) => ({
    ...provided,
    padding: '8px 12px 0',
    fontSize: '1em',
    lineHeight: 1,
    height: 50,
    backgroundColor: colours.lightGrey,
    borderRadius: '0.25em',
    boxShadow: state.isFocused ? 'rgb(0, 0, 0) 0px 0px 0px 1px' : 'none',
    border: `1px solid ${state.menuIsOpen ? 'black' : 'transparent'}`,
    '&:hover': {
      borderColor: colours.black,
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    margin: 0,
    padding: '8px 0 0',
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    fontWeight: 400,
    fontSize: 17,
    color: colours.black,
    [`@media ${device.tabletL}`]: {
      borderRadius: lg(4),
    },
    [`@media ${device.desktop}`]: {
      borderRadius: xl(4),
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    margin: 0,
    color: '#666',
    fontWeight: 400,
  }),
  indicatorsContainer: () => ({
    cursor: 'pointer',
    position: 'absolute',
    top: 6,
    right: 6,
    paddingBottom: 0,
    '& > span:hover': {
      transition: 'transform 200ms',
    },
  }),
  clearIndicator: (provided) => provided,
  option: (provided, state) => ({
    ...provided,
    border: 0,
    cursor: 'pointer',
    fontFamily: 'Delivery',
    fontSize: '1em',
    lineHeight: '1.5',
    color: colours.black,
    backgroundColor: state.isFocused ? colours.defaultGrey : colours.lightGrey,
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0.75em',
    fontWeight: 400,
  }),
  menu: (provided) => ({
    ...provided,
    overflow: 'hidden',
    padding: '0.25em 0 0',
    top: 'calc(100% - 0.25em)', // -0.25em to hide border of control
    backgroundColor: colours.lightGrey,
    zIndex: 10,
    marginTop: 0,
    marginBottom: 0,
    borderRadius: `0 0 0.25em 0.25em`,
    border: `1px solid ${colours.black}`,
    borderTop: 'none',
    borderBottom: 'none',
    boxShadow: 'rgb(0, 0, 0) 0px 1px 0px 1px',
    '& > div': {
      padding: `0 0 ${listPadding} 0`,
    },
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: `${5 * itemHeight + listPadding + 0.05}em`, // + 0.05em to counter the scroll on selected element
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#666',
    '&:hover': {
      color: '#666',
    },
    '&:focus': {
      color: colours.black,
    },
  }),
};

export const SelectError = styled.div`
  border-radius: 0.25em;
  border: 1px solid ${colours.red};
`;
